export class UploadFilesFakeDb {
  public static files = [
    {
      id: 123,
      blob: "iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mO8s1arHgAGVAI0ivsK8QAAAABJRU5ErkJggg==",
    },
  ];
}
